
import React from "react";

function MaterialMenu({ options, selectedValues, onToggle }) {
    return (
        <div className="ff-filter__menu-inner">
            <div className="ff-filter__grid ff-filter__grid--one">
                {options.map((opt) => {
                    const selected = selectedValues.indexOf(opt.value) !== -1;
                    return (
                        <button
                            key={opt.value}
                            type="button"
                            className="ff-filter__option"
                            onClick={() => onToggle(opt.value)}
                        >
                            <div className="ff-material-option">
                                <span
                                    className={
                                        "ff-material-option__box" +
                                        (selected ? " ff-material-option__box--selected" : "")
                                    }
                                />
                                <span className="ff-material-option__label">
                                    {opt.label}
                                </span>
                                {opt.count != null && (
                                    <span className="ff-material-option__count">
                                        {opt.count}
                                    </span>
                                )}
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}

export { MaterialMenu };



function ColorMenu({ options, selectedValues, onToggle }) {
    return (
        <div className="ff-filter__menu-inner">
            <div className="ff-filter__grid ff-filter__grid--two">
                {options.map((opt) => {
                    const selected = selectedValues.indexOf(opt.value) !== -1;
                    return (
                        <button
                            key={opt.value}
                            type="button"
                            className="ff-filter__option"
                            onClick={() => onToggle(opt.value)}
                        >
                            <div className="ff-color-option">
                                <span
                                    className="ff-color-option__swatch"
                                    style={{ backgroundColor: opt.swatch }}
                                />
                                <span className="ff-color-option__label">
                                    {opt.label}
                                </span>
                                {opt.count != null && (
                                    <span className="ff-color-option__count">
                                        {opt.count}
                                    </span>
                                )}
                                {selected && (
                                    <span className="ff-color-option__check">✓</span>
                                )}
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}


export { ColorMenu };

function MaterialMenuTwo({ options, selectedValues, onToggle }) {
    return (
        <div className="ff-filter__menu-inner">
            <div className="ff-filter__grid ff-filter__grid--two">
                {options.map((opt) => {
                    const selected = selectedValues.indexOf(opt.value) !== -1;
                    return (
                        <button
                            key={opt.value}
                            type="button"
                            className="ff-filter__option"
                            onClick={() => onToggle(opt.value)}
                        >
                            <div className="ff-material-option">
                                <span
                                    className={
                                        "ff-material-option__box" +
                                        (selected ? " ff-material-option__box--selected" : "")
                                    }
                                />
                                <span className="ff-material-option__label">
                                    {opt.label}
                                </span>
                                {opt.count != null && (
                                    <span className="ff-material-option__count">
                                        {opt.count}
                                    </span>
                                )}
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}

export { MaterialMenuTwo };

function MaterialMenuThree({ options, selectedValues, onToggle }) {
    return (
        <div className="ff-filter__menu-inner">
            <div className="ff-filter__grid ff-filter__grid--three">
                {options.map((opt) => {
                    const selected = selectedValues.indexOf(opt.value) !== -1;
                    return (
                        <button
                            key={opt.value}
                            type="button"
                            className="ff-filter__option"
                            onClick={() => onToggle(opt.value)}
                        >
                            <div className="ff-material-option">
                                <span
                                    className={
                                        "ff-material-option__box" +
                                        (selected ? " ff-material-option__box--selected" : "")
                                    }
                                />
                                <span className="ff-material-option__label">
                                    {opt.label}
                                </span>
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}

export { MaterialMenuThree };

function MaterialMenuFour({ options, selectedValues, onToggle }) {
    return (
        <div className="ff-filter__menu-inner">
            <div className="ff-filter__grid ff-filter__grid--four">
                {options.map((opt) => {
                    const selected = selectedValues.indexOf(opt.value) !== -1;
                    return (
                        <button
                            key={opt.value}
                            type="button"
                            className="ff-filter__option"
                            onClick={() => onToggle(opt.value)}
                        >
                            <div className="ff-material-option">
                                <span
                                    className={
                                        "ff-material-option__box" +
                                        (selected ? " ff-material-option__box--selected" : "")
                                    }
                                />
                                <span className="ff-material-option__label">
                                    {opt.label}
                                </span>
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}

export { MaterialMenuFour };

function SortMenu({ options, selectedValues, onToggle }) {
    return (
        <div className="ff-filter__menu-inner">
            <div className="ff-filter__grid ff-filter__grid--one">
                {options.map((opt) => {
                    const selected = selectedValues.indexOf(opt.value) !== -1;
                    return (
                        <button
                            key={opt.value}
                            type="button"
                            className="ff-filter__option"
                            onClick={() => onToggle(opt.value)}
                        >
                            <div className="ff-material-option">
                                <span
                                    className={
                                        "ff-material-option__box" +
                                        (selected ? " ff-material-option__box--selected" : "")
                                    }
                                />
                                <span className="ff-material-option__label">
                                    {opt.label}
                                </span>
                                {opt.count != null && (
                                    <span className="ff-material-option__count">
                                        {opt.count}
                                    </span>
                                )}
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}

export { SortMenu };